(() => {
  if (window.__tejjariProductCardSwipe) return;
  window.__tejjariProductCardSwipe = true;

  const selector = '[data-pcard-swipe]';
  const initialized = 'pcardSwipeReady';
  const preloadObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const images = entry.target.querySelectorAll('.pcard-swipe__image');
          hydrate(images[1]);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '240px 0px' })
    : null;

  function hydrate(image) {
    if (!image || image.dataset.loadFailed === 'true') return Promise.resolve(false);

    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      delete image.dataset.srcset;
    }
    if (image.dataset.src) {
      image.src = image.dataset.src;
      delete image.dataset.src;
    }

    if (image.complete) {
      if (image.naturalWidth > 0) return Promise.resolve(true);
      image.dataset.loadFailed = 'true';
      return Promise.resolve(false);
    }

    return new Promise((resolve) => {
      image.addEventListener('load', () => resolve(true), { once: true });
      image.addEventListener('error', () => {
        image.dataset.loadFailed = 'true';
        resolve(false);
      }, { once: true });
    });
  }

  function initialize(card) {
    if (card.dataset[initialized] === 'true') return;

    const link = card.querySelector('.pcard-swipe__link');
    const images = Array.from(card.querySelectorAll('.pcard-swipe__image'));
    const dots = Array.from(card.querySelectorAll('.pcard-swipe__dot'));
    if (!link || images.length < 2) return;

    card.dataset[initialized] = 'true';
    card.dataset.stackInit = '1';
    const compactDots = card.hasAttribute('data-swipe-compact') || card.querySelector('[data-swipe-compact]');
    let index = 0;
    let startX = 0;
    let startY = 0;
    let moved = false;
    let transitionId = 0;

    images.forEach((image, imageIndex) => {
      image.classList.toggle('is-active', imageIndex === 0);
      image.setAttribute('aria-hidden', imageIndex === 0 ? 'false' : 'true');
    });

    function updateDots() {
      const active = compactDots ? (index === 0 ? 0 : (index === images.length - 1 ? 2 : 1)) : index;
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
    }

    async function show(next, direction) {
      const target = Math.max(0, Math.min(images.length - 1, next));
      if (target === index) return;

      const requestId = ++transitionId;
      const loaded = await hydrate(images[target]);
      if (!loaded || requestId !== transitionId) return;

      const previous = index;
      index = target;
      const leavingClass = direction === 'right' ? 'is-leaving-right' : 'is-leaving-left';
      const enteringClass = direction === 'right' ? 'is-entering-right' : 'is-entering-left';

      images.forEach((image) => image.classList.remove(
        'is-active', 'is-leaving-left', 'is-leaving-right', 'is-entering-left', 'is-entering-right'
      ));
      images.forEach((image, imageIndex) => image.setAttribute('aria-hidden', imageIndex === index ? 'false' : 'true'));
      images[previous].classList.add(leavingClass);
      images[index].classList.add(enteringClass, 'is-active');
      updateDots();

      window.setTimeout(() => {
        images[previous].classList.remove(leavingClass);
        images[index].classList.remove(enteringClass);
      }, 260);

      hydrate(images[index + 1]);
      hydrate(images[index - 1]);
    }

    link.addEventListener('touchstart', (event) => {
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      startX = touch.clientX;
      startY = touch.clientY;
      moved = false;
      hydrate(images[index + 1]);
      hydrate(images[index - 1]);
    }, { passive: true });

    link.addEventListener('touchend', (event) => {
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (Math.abs(dx) <= 35 || Math.abs(dx) <= Math.abs(dy)) return;

      moved = true;
      const rtl = document.documentElement.dir === 'rtl';
      const forward = rtl ? dx > 0 : dx < 0;
      show(index + (forward ? 1 : -1), forward ? 'left' : 'right');
    }, { passive: true });

    link.addEventListener('click', (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      window.setTimeout(() => { moved = false; }, 80);
    }, true);

    updateDots();
    if (preloadObserver) preloadObserver.observe(card);
  }

  function scan(root = document) {
    if (root.matches && root.matches(selector)) initialize(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(initialize);
  }

  let scheduled = false;
  const queueScan = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queueScan);
  document.addEventListener('recommendations:loaded', queueScan);
})();
